import { api } from '../api.js';
import { state, setProject } from '../state.js';
import { navigate, RouterLink } from '../router.js';
import { Empty, plural } from '../ui.js';
import { ensureDictionaries } from '../bootstrap.js';

export const Projects = {
  components: { RouterLink, Empty },
  data() {
    return { creating: false, name: '', track: 'devops', grade: 'junior',
      personality: '', error: '' };
  },
  async created() {
    await ensureDictionaries();
    this.personality = state.dictionaries.defaults?.personality || 'neutral';
  },
  computed: {
    ready() { return Boolean(state.dictionaries.tracks?.length); },
    projects() { return state.projects; },
    tracks() { return state.dictionaries.tracks; },
    grades() { return state.dictionaries.grades; },
    personalities() { return state.dictionaries.personalities || []; },
  },
  methods: {
    plural,
    trackName(id) { return this.tracks.find((t) => t.id === id)?.name || id; },
    gradeName(id) { return this.grades.find((g) => g.id === id)?.name || id; },

    async create() {
      this.error = '';
      if (!this.name.trim()) { this.error = 'Нужно название'; return; }
      try {
        const project = await api.post('/api/projects', {
          name: this.name.trim(), track: this.track, grade: this.grade,
          personality: this.personality,
        });
        // Перечитываем список целиком, а не дописываем локально: при
        // возврате на страницу дописанное складывалось с полученным с сервера.
        const { rows } = await api.get('/api/projects');
        state.projects = rows;
        setProject(project.id);
        navigate(`/project/${project.id}`);
      } catch (e) {
        this.error = e.message;
      }
    },

    open(p) { setProject(p.id); navigate(`/project/${p.id}`); },
  },
  template: `
    <!-- data-ready: справочники доехали и страница больше не пересобирается.
         Без такого признака проверки ловят момент, когда клик уходит в узел,
         который уже заменён, и молча теряется. Ждать «тишины в сети» тут
         нельзя: приложение постоянно опрашивает состояние раннера. -->
    <div class="page" :data-ready="String(ready)">
      <h1>Проекты</h1>
      <p class="sub">
        Проект — это отдельная память: свои материалы, собесы и разборы.
        Соседний проект о них не знает.
      </p>

      <div class="card" v-if="creating">
        <h3 style="margin-top:0">Новый проект</h3>
        <div class="field">
          <label>Название</label>
          <input v-model="name" placeholder="напр.: Собесы на middle+ DevOps" @keyup.enter="create">
        </div>
        <div class="row" style="margin-top:12px;gap:12px">
          <div style="flex:1">
            <label>Направление</label>
            <select v-model="track">
              <option v-for="t in tracks" :key="t.id" :value="t.id">{{ t.name }}</option>
            </select>
          </div>
          <div style="flex:1">
            <label>Грейд</label>
            <select v-model="grade">
              <option v-for="g in grades" :key="g.id" :value="g.id">{{ g.name }}</option>
            </select>
          </div>
        </div>
        <div class="field">
          <label>Характер интервьюера</label>
          <select v-model="personality">
            <option v-for="p in personalities" :key="p.id" :value="p.id">{{ p.name }} — {{ p.hint }}</option>
          </select>
        </div>
        <p class="err" v-if="error" style="margin-top:10px">{{ error }}</p>
        <div class="row" style="margin-top:14px">
          <button class="primary" @click="create">Создать</button>
          <button class="ghost" @click="creating = false">Отмена</button>
        </div>
      </div>

      <div class="row" style="margin:18px 0" v-if="!creating">
        <button class="primary" @click="creating = true">+ Новый проект</button>
      </div>

      <Empty v-if="!projects.length && !creating"
             title="Пока пусто"
             hint="Заведи первый проект — например, под конкретную вакансию или под подготовку к своему грейду.">
      </Empty>

      <div class="grid" v-else>
        <div class="card" v-for="p in projects" :key="p.id"
             style="cursor:pointer" @click="open(p)">
          <div class="row">
            <strong style="flex:1">{{ p.name }}</strong>
            <span class="tag">{{ gradeName(p.grade) }}</span>
          </div>
          <p class="faint" style="margin:6px 0 0">{{ trackName(p.track) }}</p>
          <div class="row wrap marks-bottom" style="gap:6px">
            <span class="tag">{{ p.sessions }} {{ plural(p.sessions, 'собес', 'собеса', 'собесов') }}</span>
            <span class="tag warn" v-if="Number(p.due)">
              {{ p.due }} {{ plural(p.due, 'карточка ждёт', 'карточки ждут', 'карточек ждут') }}
            </span>
            <span class="tag" v-if="Number(p.files)">
              {{ p.files }} {{ plural(p.files, 'файл', 'файла', 'файлов') }}</span>
            <span class="tag ok" v-if="p.briefed">материалы разобраны</span>
            <span class="tag warn" v-else>без материалов</span>
          </div>
        </div>
      </div>
    </div>`,
};
